module.exports = __webpack_public_path__ + "static/scholle2-37515a387165391b84e2664652f0788a.png";